import {
  type ApiRoleStrategy,
  ROLES,
  api,
  useQuery,
  useRoleConf,
} from "@pharmupp/p3-front-commons"

export const useCommitteeSummary = () => {
  const { endpoint, queryKey } = useRoleConf(committeeSummaryApiConf)

  return useQuery({
    queryKey,
    queryFn: () => api.get<{ inactiveMembersCount: number }>(endpoint),
  })
}

export const committeeSummaryApiConf: ApiRoleStrategy = {
  [ROLES.ADHERENT_HOLDER]: {
    endpoint: "/api/employee-committees/adherent/members/summary",
    queryKey: ["employee-committees", "adherent", "members", "summary"],
  },
}
